// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__33dba","productName":"Table_productName__26-2x"};